<template lang="pug">

  div
    .title {{ item.title }} <small>({{ item.latitude }}, {{ item.longitude }})</small>
    .subtitle {{ item.location }}

</template>

<script>
  export default {
    props: [ 'item' ]
  }
</script>

<style lang="less" scoped>
  .title {
    font-size: 18px;
    margin-bottom: 3px;

    small {
      font-size: 11px;
    }
  }
  .subtitle {
    font-size: 12px;
  }
</style>




// WEBPACK FOOTER //
// vauto-projectName.vue?3c865688